import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { URL_SERVICIOS } from 'src/app/config/config';
import { AuthService } from 'src/app/shared/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class BuscadorGlobalService {

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}

  buscar(texto: string) {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.authService.token
    });

    const URL = URL_SERVICIOS + '/buscador-global?buscar=' + encodeURIComponent(texto);

    return this.http.get(URL, { headers });
  }
}